import {isNullOrUndefined} from "../../services/Validator";

export default function SystemAppScreenHeader({title, icon, onInfoClick, isBrevetDisplay}) {
    // Used through the app to display screen header made of title
    // and eventually info

    // BUILD
    if (isNullOrUndefined(title) || isNullOrUndefined(icon))
        return null
    return (
        <div className={`w-full h-[48px] min-h-[48px] flex justify-between items-center ${isBrevetDisplay ? "bg-greenStar/10" : "bg-primary/10"} rounded-[12px] pl-[8px] pr-[16px]`}>
            <div className={"flex justify-start items-center space-x-[10px]"}>
                <div className={`${isBrevetDisplay ? "bg-greenStar/30" : "bg-primary/30"} w-[32px] min-w-[32px] h-[32px] min-h-[32px] flex justify-center items-center rounded-[8px]`}>
                    <i className={`material-icons text-[16px] ${isBrevetDisplay ? "text-greenStar" : "text-primary"} `}>
                        {icon}
                    </i>
                </div>
                <span className={"font-bold text-[18px] text-white"}>
                    {title}
                </span>
            </div>
            {!isNullOrUndefined(onInfoClick) && (
                <div className={"cursor-pointer flex justify-center items-center rounded-full w-[16px] min-w-[16px] h-[16px] min-h-[16px] bg-greyLight7 hover:bg-greyLight9"}
                     onClick={onInfoClick}>
                    <span className={`text-[12px] text-black font-normal`}>
                        {"?"}
                    </span>
                </div>
            )}
        </div>
    );
}